export default __webpack_public_path__ + "static/media/256.de803672.jpg";